module.exports = __webpack_public_path__ + "6b4ceb50f3718f217debc46fd017cfc1.jpg";